<div class="zeva-card transparent action-prompt">
  <div class="card-header action-header">
    <div>
      @if (prompts.icon || prompts.matIcon) {
        <div class="title-icon">
          @if (prompts.icon) { <mat-icon [svgIcon]="prompts.icon"></mat-icon> }
          @if (prompts.matIcon) {
            <mat-icon [fontSet]="prompts.matIconFontSet ?? 'material-icons'">
              {{ prompts.matIcon }}
            </mat-icon>
          }
        </div>
      }
      <span class="mat-headline-3">{{ prompts.title }}</span>
    </div>

    @if (!prompts.disableClose) {
      <button
        mat-icon-button
        mat-dialog-close
        tabindex="-1"
        style="margin: -0.5rem -0.5rem 0 -0.5rem"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="card-body" style="height: fit-content">
    @if (prompts.heading) {
      <div class="heading">
        @if (prompts.heading) {
          <p class="mat-headline-4">{{ prompts.heading }}</p>
        }
      </div>
    }

    @if (prompts.message || prompts.messageTml || prompts.messageHtml || prompts.messages || prompts.centeredMessage) {
      <div class="action left">
        @if (prompts.message) {
          <p>{{ prompts.message }}</p>
        }
        @if (prompts.centeredMessage) {
          <p style="text-align: center;">{{ prompts.centeredMessage }}</p>
        }
        @if (prompts.messages) {
          @for (message of prompts.messages; track message) {
            <p class="messages">{{ message }}</p>
          }
        }
        @if (prompts.messageTml) {
          <ng-container
            *ngTemplateOutlet="prompts.messageTml; context: prompts.messageContext"
          ></ng-container>
        }
        @if (prompts.messageHtml) {
          <div [innerHTML]="prompts.messageHtml"></div>
        }
      </div>
    }
  </div>

  <div
    class="card-footer action-footer"
    [class.action-footer--paired]="
      prompts.removeCancelAction && !!prompts.otherActionCaption && !prompts.removeConfirmAction
    "
  >
    @if (!prompts.removeCancelAction) {
      <button
        mat-stroked-button
        color="primary"
        (click)="onCancel()"
        tabindex="-1"
      >
        {{ prompts.cancelActionCaption ?? 'Cancel' }}
      </button>
    }

    @if (prompts.otherActionCaption) {
      <button
        mat-flat-button
        color="primary"
        (click)="onOther(prompts.otherActionCaption)"
        tabindex="-1"
      >
        {{ prompts.otherActionCaption }}
      </button>
    }

    @if (!prompts.removeConfirmAction) {
      <button
        mat-flat-button
        color="primary"
        [disabled]="
          (prompts.disableConfirmWhile ? prompts.disableConfirmWhile() : false) ||
          (waitingConfirmCallback)
        "
        [ngClass]="{ 'loading-shimmer': waitingConfirmCallback }"
        (click)="onConfirm()"
        tabindex="-1"
      >
        {{ prompts.confirmActionCaption ?? 'Confirm' }}
      </button>
    }
  </div>
</div>
